import React, { Component, Fragment } from 'react';
import enhance from './InfluencerSettings.enhancer';
import { find } from 'lodash';
import queryString from 'query-string';
import { Grid } from '@material-ui/core';
import ProfilePictureUpload from '../../../components/sign-up/ProfilePictureUpload';
import ChipInput from 'material-ui-chip-input';
import Typography from '@material-ui/core/Typography';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import Divider from '@material-ui/core/Divider';
import ListItemText from '@material-ui/core/ListItemText';
import Paper from '@material-ui/core/Paper';
import Fab from '@material-ui/core/Fab';
import CreateIcon from '@material-ui/icons/Create';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import PersonIcon from '@material-ui/icons/Person';
import PaymentIcon from '@material-ui/icons/Payment';
import LockIcon from '@material-ui/icons/Lock';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import { countries, industrySelections } from '../../../constants';
import axios from 'axios';
import MenuItem from '@material-ui/core/MenuItem';
import {
  getCountryKeyFromValue,
  getCountryValueFromKey
} from '../../../helpers/countryHelper';

class InfluencerSettings extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isDeleteAccountModalOpen: false,
      activeIndex: 1,
      editingProfile: false,
      currentProfile: {},
      newProfile: {},
      loadedPaypalInfo: false,
      showit: false
    };
  }

  componentDidMount() {
    // popuate initial data
    this.setState({
      currentProfile: this.props.profile,
      newProfile: this.props.profile
    });

    const { isScriptLoaded, isScriptLoadSucceed } = this.props;
    if (isScriptLoaded && isScriptLoadSucceed) {
      this.loadPaypalButton();
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.profile) {
      this.setState({
        currentProfile: nextProps.profile,
        newProfile: nextProps.profile
      });
    }
    if (nextProps.isScriptLoaded && !this.props.isScriptLoaded) {
      // load finished
      if (nextProps.isScriptLoadSucceed) {
        this.loadPaypalButton();
      } else this.props.onError();
    }
    if (nextProps.paypalResponseValue && !this.state.loadedPaypalInfo) {
      this.setState({
        loadedPaypalInfo: true
      });
      //get the access token from the access code from cloud function
      this.props.firebase
        .auth()
        .currentUser.getIdToken(/* forceRefresh */ true)
        .then(function(idToken) {
          return axios
            .post(`${process.env.REACT_APP_FIREBASE_URL}/getUserPaypalInfo`, {
              idToken,
              accessCode: nextProps.paypalResponseValue.code
            })
            .then(res => {
              if (res.status === 200 && res.data) {
                // need to request email scope from paypal
                // const primaryEmail = find(
                //   res.data.emails,
                //   email => email.primary
                // );
                const paypalInfo = {
                  // email: primaryEmail
                  //   ? primaryEmail.value
                  //   : res.data.emails[0].value,
                  displayName: res.data.name,
                  payerId: res.data.payer_id
                };
                nextProps.handleUpdatePaypalInfo(paypalInfo);
              }
            })
            .catch(err => {
              const ff = 5;

            });
        });
    }
  }

  loadPaypalButton() {
    const script = document.createElement('script');
    script.type = 'text/javascript';
    var ref = document.querySelector('#cwppButton');
    script.async = true;
    script.innerHTML = `paypal.use( ['login'], (login) => {
      login.render ({
        "appid":"${process.env.REACT_APP_PAYPAL_CLIENT_ID_INFLUENCER}",
        ${process.env.REACT_APP_PAYPAL_ENV === 'production' ? '' : `"authend":"sandbox",`}
        "scopes":"openid profile https://uri.paypal.com/services/paypalattributes",
        "containerid":"cwppButton",
        "responseType":"code id_Token",
        "locale":"en-us",
        "buttonType":"CWP",
        "buttonShape":"pill",
        "buttonSize":"lg",
        "fullPage":"true",
        "returnurl":"${process.env.REACT_APP_PAYPAL_SIGNUP_CALLBACK}"
      })
    })`;
    ref.parentNode.insertBefore(script, ref.nextSibling);
  }

  handleActiveIndexChange(newIndex) {
    this.setState({
      activeIndex: newIndex
    });
  }

  editProfile() {
    this.setState({
      editingProfile: true
    });
  }

  cancelProfileEdit() {
    this.setState({
      newProfile: this.state.currentProfile,
      editingProfile: false
    });
  }

  saveProfileEdit() {
    const pp = getCountryKeyFromValue(this.state.newProfile.country);
    this.props.handleUpdateProfile({
      ...this.state.newProfile,
      country: getCountryKeyFromValue(this.state.newProfile.country)
    });
    this.setState({
      editingProfile: false
    });
  }

  handleInterestAdd = chip => {
    this.setState({
      newProfile: {
        ...this.state.newProfile,
        interests: this.state.newProfile.interests
          ? [...this.state.newProfile.interests, chip]
          : [chip]
      }
    });
  };

  deleteAccountClick() {
    this.setState({
      isDeleteAccountModalOpen: true
    });
  }

  handleDeleteAccountAccept() {
    this.props.handleDeleteAccount();
  }

  handleInterestRemove = (chip, index) => {
    this.setState({
      newProfile: {
        ...this.state.newProfile,
        interests: this.state.newProfile.interests
          .slice(0, index)
          .concat(
            this.state.newProfile.interests.slice(
              index + 1,
              this.state.newProfile.interests.length
            )
          )
      }
    });
  };

  handleInfoChange = e => {
    this.setState({
      newProfile: {
        ...this.state.newProfile,
        [e.target.name]:
          e.target.name === 'age'
            ? Number.parseInt(e.target.value)
            : e.target.value
      }
    });
  };

  handleCloseDeleteAccountModal() {
    this.setState({
      isDeleteAccountModalOpen: false
    });
  }

  render() {
    const { activeIndex, editingProfile, newProfile } = this.state;
    const { profile, auth, classes } = this.props;
    return (
      <React.Fragment>
        <div className={classes.layout}>
          <Grid container direction="row" spacing={4}>
            <Grid item className={classes.leftPageDiv}>
              <List component="nav" aria-label="Main mailbox folders">
                <ListItem
                  selected={activeIndex === 1}
                  button
                  onClick={() => this.handleActiveIndexChange(1)}
                >
                  <ListItemIcon className={classes.listIcon}>
                    <PersonIcon />
                  </ListItemIcon>
                  <ListItemText primary="Profile Info" />
                </ListItem>
                <ListItem
                  selected={activeIndex === 2}
                  button
                  onClick={() => this.handleActiveIndexChange(2)}
                >
                  <ListItemIcon className={classes.listIcon}>
                    <PaymentIcon />
                  </ListItemIcon>
                  <ListItemText primary="Payment and Billing" />
                </ListItem>
                <ListItem
                  selected={activeIndex === 3}
                  button
                  onClick={() => this.handleActiveIndexChange(3)}
                >
                  <ListItemIcon className={classes.listIcon}>
                    <LockIcon />
                  </ListItemIcon>
                  <ListItemText primary="Manage Account" />
                </ListItem>
              </List>
            </Grid>
            <Grid item sm xs={12}>
              <Paper>
                {activeIndex === 1 && (
                  <List className={classes.profile_info}>
                    <ListItem className={classes.profile__header}>
                      <Grid
                        container
                        alignItems="center"
                        justify="space-between"
                      >
                        <Grid item>
                          <Typography variant="h6">Profile Info</Typography>
                        </Grid>
                        <Grid item>
                          <Fab
                            size="medium"
                            color="primary"
                            className={classes.button}
                            onClick={this.editProfile.bind(this)}
                          >
                            <CreateIcon fontSize="small" />
                          </Fab>
                        </Grid>
                      </Grid>
                    </ListItem>
                    <Divider />
                    <div
                      className={editingProfile ? '' : classes.settingsOverlay}
                    ></div>
                    <ListItem className={classes.section}>
                      <Grid container direction="column" justify="center">
                        <Grid item>
                          <ProfilePictureUpload />
                        </Grid>
                      </Grid>
                    </ListItem>
                    <Divider />
                    <ListItem className={classes.section}>
                      <Grid container direction="column" justify="center">
                        <Grid item>
                          <Typography
                            variant="h6"
                            gutterBottom
                            color="textSecondary"
                          >
                            Country
                          </Typography>
                        </Grid>
                        <Grid item>
                          <TextField
                            id="country"
                            name="country"
                            select
                            className={classes.select}
                            SelectProps={{
                              MenuProps: {
                                className: classes.selectMenu
                              }
                            }}
                            onChange={this.handleInfoChange.bind(this)}
                            margin="normal"
                            variant="outlined"
                            value={getCountryValueFromKey(newProfile.country)}
                            InputProps={{
                              readOnly: !editingProfile
                            }}
                          >
                            {countries.map((item, i) => (
                              <MenuItem key={item.key} value={item.value}>
                                {item.value}
                              </MenuItem>
                            ))}
                          </TextField>
                        </Grid>
                      </Grid>
                    </ListItem>
                    <ListItem className={classes.section}>
                      <Grid container direction="column" justify="center">
                        <Grid item>
                          <Typography
                            variant="h6"
                            gutterBottom
                            color="textSecondary"
                          >
                            Age
                          </Typography>
                        </Grid>
                        <Grid item>
                          <TextField
                            id="age"
                            name="age"
                            value={newProfile.age}
                            type="number"
                            className={classes.ageInput}
                            variant="outlined"
                            InputProps={{
                              readOnly: !editingProfile
                            }}
                            onChange={this.handleInfoChange.bind(this)}
                          />
                        </Grid>
                      </Grid>
                    </ListItem>
                    <ListItem className={classes.section}>
                      <Grid container direction="column" justify="center">
                        <Grid item>
                          <Typography
                            variant="h6"
                            gutterBottom
                            color="textSecondary"
                          >
                            Gender
                          </Typography>
                        </Grid>
                        <Grid item>
                          <TextField
                            id="gender"
                            name="gender"
                            select
                            className={classes.select}
                            SelectProps={{
                              MenuProps: {
                                className: classes.selectMenu
                              }
                            }}
                            onChange={this.handleInfoChange.bind(this)}
                            margin="normal"
                            variant="outlined"
                            value={newProfile.gender}
                            InputProps={{
                              readOnly: !editingProfile
                            }}
                          >
                            {['Male', 'Female'].map((item, i) => (
                              <MenuItem key={i} value={item}>
                                {item}
                              </MenuItem>
                            ))}
                          </TextField>
                        </Grid>
                      </Grid>
                    </ListItem>
                    <ListItem className={classes.section}>
                      <Grid container direction="column" justify="center">
                        <Grid item>
                          <Typography
                            variant="h6"
                            gutterBottom
                            color="textSecondary"
                          >
                            Content Type
                          </Typography>
                        </Grid>
                        <Grid item>
                          <TextField
                            id="industry"
                            name="industry"
                            select
                            className={classes.select}
                            SelectProps={{
                              MenuProps: {
                                className: classes.selectMenu
                              }
                            }}
                            onChange={this.handleInfoChange.bind(this)}
                            margin="normal"
                            variant="outlined"
                            value={newProfile.industry}
                            InputProps={{
                              readOnly: !editingProfile
                            }}
                          >
                            {industrySelections.map((item, i) => (
                              <MenuItem key={i} value={item}>
                                {item}
                              </MenuItem>
                            ))}
                          </TextField>
                        </Grid>
                      </Grid>
                    </ListItem>
                    <ListItem className={classes.section}>
                      <Grid container direction="column" justify="center">
                        <Grid item>
                          <Typography
                            variant="h6"
                            gutterBottom
                            color="textSecondary"
                          >
                            Audience
                          </Typography>
                        </Grid>
                        <Grid item>
                          <TextField
                            id="audience"
                            name="audience"
                            value={newProfile.audience}
                            variant="outlined"
                            fullWidth
                            InputProps={{
                              readOnly: !editingProfile
                            }}
                            onChange={this.handleInfoChange.bind(this)}
                          />
                        </Grid>
                      </Grid>
                    </ListItem>
                    <ListItem className={classes.section}>
                      <Grid container direction="column" justify="center">
                        <Grid item>
                          <Typography
                            variant="h6"
                            gutterBottom
                            className="info-helper-text"
                            color="textSecondary"
                          >
                            Content Description
                          </Typography>
                        </Grid>
                        <Grid item>
                          <TextField
                            id="description"
                            name="description"
                            value={newProfile.description}
                            variant="outlined"
                            fullWidth
                            InputProps={{
                              readOnly: !editingProfile
                            }}
                            onChange={this.handleInfoChange.bind(this)}
                          />
                        </Grid>
                      </Grid>
                    </ListItem>
                    <ListItem className={classes.section}>
                      <Grid container direction="column" justify="center">
                        <Grid item>
                          <Typography
                            variant="h6"
                            gutterBottom
                            className="info-helper-text"
                            color="textSecondary"
                          >
                            Content Interests
                          </Typography>
                        </Grid>
                        <Grid item>
                          <ChipInput
                            value={
                              newProfile.interests ? newProfile.interests : []
                            }
                            defaultValue={newProfile.interests}
                            className={classes.chips}
                            onAdd={chip => this.handleInterestAdd(chip)}
                            onDelete={(chip, index) =>
                              this.handleInterestRemove(chip, index)
                            }
                            color="primary"
                            placeholder="type and press enter to add"
                            alwaysShowPlaceholder={false}
                            disabled={!editingProfile}
                          />
                        </Grid>
                      </Grid>
                    </ListItem>
                    <Divider />
                    {editingProfile && (
                      <Fragment>
                        <Divider />
                        <ListItem>
                          <Grid container justify="flex-end" spacing={2}>
                            <Grid item>
                              <Button
                                variant="contained"
                                color="secondary"
                                onClick={this.cancelProfileEdit.bind(this)}
                              >
                                Cancel
                              </Button>
                            </Grid>
                            <Grid item>
                              <Button
                                variant="contained"
                                color="primary"
                                className={classes.button}
                                onClick={this.saveProfileEdit.bind(this)}
                              >
                                Save
                              </Button>
                            </Grid>
                          </Grid>
                        </ListItem>
                      </Fragment>
                    )}
                  </List>
                )}
                <List
                  className={
                    activeIndex === 2
                      ? classes.profile_info
                      : classes.hidden_profile_info
                  }
                >
                  <ListItem className={classes.profile__header}>
                    <Grid container alignItems="center" justify="space-between">
                      <Grid item>
                        <Typography variant="h6">
                          Payment and Billing
                        </Typography>
                      </Grid>
                    </Grid>
                  </ListItem>

                  <ListItem>
                    <div className={classes.otherPage}>
                      <Grid container justify="center" direction="column">
                        {profile.isLoaded &&
                          profile.paypalInfo !== null &&
                          profile.paypalInfo !== undefined && (
                            <React.Fragment>
                              <div>
                                <CheckCircleIcon
                                  className={classes.paypalCheck}
                                />
                                <Typography variant="h6" display="inline">
                                  Successfully Linked Paypal Account
                                </Typography>
                                <Divider />
                              </div>
                              {/* <div className={classes.paypalFieldContainer}>
                                <Typography
                                  display="inline"
                                  className={classes.paypalField}
                                >
                                  Email:{' '}
                                </Typography>
                                <Typography display="inline">
                                  {profile.isLoaded && profile.paypalInfo.email}
                                </Typography>
                              </div> */}
                              <div className={classes.paypalFieldContainer}>
                                <Typography
                                  display="inline"
                                  className={classes.paypalField}
                                >
                                  User:{' '}
                                </Typography>
                                <Typography display="inline">
                                  {profile.isLoaded &&
                                    profile.paypalInfo.displayName}
                                </Typography>
                              </div>
                              <div className={classes.paypalFieldContainerText}>
                                <Typography align="center" justifu="center">
                                  Want to switch Paypal accounts? Connect again
                                  below.
                                </Typography>
                              </div>
                            </React.Fragment>
                          )}
                        <div
                          id="cwppButton"
                          className={classes.paypalButtonContainer}
                        ></div>
                      </Grid>
                    </div>
                  </ListItem>
                </List>
                {activeIndex === 3 && (
                  <List className={classes.profile_info}>
                    <ListItem className={classes.profile__header}>
                      <Grid
                        container
                        alignItems="center"
                        justify="space-between"
                      >
                        <Grid item>
                          <Typography variant="h6">Manage Account</Typography>
                        </Grid>
                      </Grid>
                    </ListItem>
                    <ListItem>
                      <div className={classes.otherPage}>
                        <Grid container justify="center">
                          <Button
                            variant="contained"
                            color="secondary"
                            onClick={this.deleteAccountClick.bind(this)}
                          >
                            Delete Account
                          </Button>
                        </Grid>
                      </div>
                    </ListItem>
                  </List>
                )}
              </Paper>
            </Grid>
          </Grid>
        </div>
        <Dialog
          id="delete-account-dialog"
          open={this.state.isDeleteAccountModalOpen}
          onClose={this.props.handleClose}
          // classes={classes.modalStyles}
          disableAutoFocus={true}
          onBackdropClick={this.handleCloseDeleteAccountModal.bind(this)}
          PaperProps={{
            style: {
              minHeight: '150px',
              minWidth: '350px',
              padding: '20px'
            }
          }}
        >
          <Typography variant="body1" align="center">
            Are you sure you want to permanently delete your account?
          </Typography>
          <div className={classes.deleteButtonsContainer}>
            <Button
              variant="outlined"
              color="secondary"
              onClick={this.handleCloseDeleteAccountModal.bind(this)}
              fullWidth
              className={classes.deleteCancelButtons}
            >
              Cancel
            </Button>
            <Button
              variant="outlined"
              color="secondary"
              onClick={this.handleDeleteAccountAccept.bind(this)}
              fullWidth
              className={classes.deleteAcceptButtons}
            >
              Delete
            </Button>
          </div>
        </Dialog>
      </React.Fragment>
    );
  }
}

export default enhance(InfluencerSettings);



// WEBPACK FOOTER //
// ./src/components/influencer/settings/InfluencerSettings.js